import PropTypes from 'prop-types';
import React from 'react';

// Import our icons
import Add from './add';
import AdvertAnimated from './adverts/animated';
import AdvertCustom from './adverts/custom';
import AdvertInteractive from './adverts/interactive';
import AdvertStatic from './adverts/static';
import AdvertVideo from './adverts/video';
import Android from './apps/android';
import Amex from './payment/amex';
import Apple from './apps/apple';
import Appstore from './apps/appstore';
import Arrow from './arrow';
import ArrowCircle from './arrow-circle';
import Bancontact from './payment/bancontact';
import Browser from './browser';
import CardsStack from './cards-stack';
import CheckCircle from './checkmark-circle';
import CheckCircleLight from './check-circle-light';
import Chrome from './apps/chrome';
import Circle from './circle';
import Cli from './apps/cli';
import Close from './close';
import Collect from './collect';
import DoubleArrows from './double-arrows';
import DownloadActive from './download-active';
import DownloadArrow from './download-arrow';
import DownloadBox from './download-box';
import DownloadSmall from './download-small';
import Error from './error';
import ExternalLink from './externallink';
import Facebook from './social/facebook';
import Fallback from './fallback';
import Folder from './folder';
import Forward from './forward';
import Hamburger from './hamburger';
import Ideal from './payment/ideal';
import Info from './info';
import Instagram from './social/instagram';
import Landscape from './landscape';
import Lines from './lines';
import Link from './link';
import Loading from './loading';
import Locked from './locked';
import Logo from './logo';
import MailClient from './mailclient';
import MailClientSmall from './mailclient-small';
import MailContent from './mail-content';
import Mastercard from './payment/mastercard';
import More from './more';
import Padlock from './padlock';
import PayPal from './payment/paypal';
import Phone from './phone';
import Pointer from './pointer';
import QRScanner from './qr-scanner';
import Remove from './remove';
import Search from './search';
import SearchCircle from './search-circle';
import Sofort from './payment/sofort';
import PlusCircle from './plus-circle';
import TransferAddMultiple from './transfer/add-multiple';
import TransferBack from './transfer/back';
import TransferComplete from './transfer/complete';
import TransferError from './transfer/error';
import TransferNext from './transfer/next';
import TransferOptions from './transfer/options';
import TransferPlus from './transfer/plus';
import TransferProcessing from './transfer/processing';
import TransferReady from './transfer/ready';
import Twitter from './social/twitter';
import Unlock from './unlock';
import Valid from './valid';
import Video from './video';
import Visa from './payment/visa';
import Youtube from './social/youtube';

// We'll need to define them as well, for easy lookups.
export const availableIcons = {
  Add,
  AdvertAnimated,
  AdvertCustom,
  AdvertInteractive,
  AdvertStatic,
  AdvertVideo,
  Amex,
  Android,
  Apple,
  Appstore,
  Arrow,
  ArrowCircle,
  Bancontact,
  Browser,
  CardsStack,
  CheckCircle,
  CheckCircleLight,
  Chrome,
  Cli,
  Circle,
  Close,
  Collect,
  DoubleArrows,
  DownloadActive,
  DownloadArrow,
  DownloadBox,
  DownloadSmall,
  Error,
  ExternalLink,
  Facebook,
  Fallback,
  Folder,
  Forward,
  Hamburger,
  Ideal,
  Info,
  Instagram,
  Landscape,
  Lines,
  Link,
  Loading,
  Locked,
  Logo,
  MailClient,
  MailClientSmall,
  MailContent,
  Mastercard,
  More,
  Padlock,
  PayPal,
  Phone,
  PlusCircle,
  Pointer,
  QRScanner,
  Remove,
  Search,
  SearchCircle,
  Sofort,
  TransferAddMultiple,
  TransferBack,
  TransferComplete,
  TransferError,
  TransferNext,
  TransferOptions,
  TransferPlus,
  TransferProcessing,
  TransferReady,
  Twitter,
  Unlock,
  Valid,
  Video,
  Visa,
  Youtube,
};

// Then we have our generic <Icon /> component
// that will forward all props to the selected icon type.
export default class Icon extends React.Component {
  static propTypes = {
    type: PropTypes.string,
  };

  // This is a separate function to prevent the optimizer
  // from making this a stateless component, which it needs
  // to be in some scenarios (when using refs).
  doesTypeExist(type) {
    if (typeof availableIcons[type] === 'undefined') {
      return false;
    }

    return true;
  }

  render() {
    if (!this.doesTypeExist(this.props.type)) {
      throw `InvalidIconType; ${this.props.type}`;
    }

    // Render the icon with forwarded props
    const AvailableIconsTag = availableIcons[this.props.type];
    return <AvailableIconsTag {...this.props} />;
  }
}
